let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("740y2")).then(() => parcelRequire('3hX8x'));